import { FinancialAccountTfsaType } from '@/modules/financialaccount/constants/FinancialAccountTfsaType';
import { FinancialAccountMeta } from '@/modules/financialaccount/models/meta/FinancialAccountMeta';

export class FinancialAccountTfsaMeta extends FinancialAccountMeta {
  constructor(model: Partial<FinancialAccountTfsaMeta> = {}) {
    super(model);

    this.type = model.type ?? FinancialAccountTfsaType.NONE.key;
  }
}
